export default __webpack_public_path__ + "static/media/Dmitri-Particle_0001_SpikeImpactDust.04e8c944.png";